import color from "../../../../constants/color";

const style = {
  heading:{
    fontSize:"20px",
    fontWeight:"600",
    pl:2
  },
  checkinBtn:
  { borderRadius: 50, 
    backgroundColor: "#28AA4A",
    color: "#fff", 
    ml: "8px" ,
    textTransform: "none", 
    fontSize: "12px",
  },
  TableHead: {
    color: color.lightText,
    fontWeight: "400",
    whiteSpace:"nowrap"

  },
  tableAlign: {
    borderBottom: 0, 
    display: "flex", 
    alignItems: "center",
    mt:1
  },
  tableIcon: {
    borderBottom: 0, 
    display: "flex", 
    alignItems: "center" ,
  },
  tableData: {
    borderBottom: 0, 
    whiteSpace:"nowrap"

  },
};
export default style